import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DataTable,
  Field,
  DateTimeField,
  ContractEONType,
  CurrencyField,
  ResponsibleField,
} from '../../commons/DataTable';
import CustomerTypeField from '../../commons/DataTable/CustomerTypeField';
import AdminStateEnergyField from '../../commons/DataTable/AdminStateEnergyField';
import ActionsField from './ActionsField';
import CurrencyFieldInitialFixedValue from '../../commons/DataTable/CurrencyFieldInitialFixedValue';
import CurrencyFieldCentMc from '../../commons/DataTable/CurrencyFieldCentMc';
import ManageDocument from './ManageDocument';
import CurrentAdminField from '../../commons/DataTable/CurrentAdminField';

function ContractsTable({
  data,
  total,
  offset,
  limit,
  onFilter,
  toggleHistoryModal,
  handleFileListView,
}) {
  const [t] = useTranslation('IAF_INVOICES');

  return (
    <DataTable
      data={data}
      total={total}
      offset={offset}
      limit={limit}
      onFilter={onFilter}
      emptyText={t('COMMON:NO_DATA')}
    >
      <Field title="POD/PDR" source="pod_pdr" />
      <Field
        title="Nome Fornitore"
        source="supplier.businessName"
        className="text-left"
      />
      <Field title="Partita iva fornitore" source="supplier.taxCode" />
      <Field title="Nome cliente" source="condo_name" className="text-left" />
      <CustomerTypeField title="Tipo Cliente" source="customerType" />
      <Field title="Partita iva detentore" source="currentAdminInfo.taxCode" />
      <Field title="Partita IVA cliente" source="condo_vat_cf" />
      <DateTimeField
        title="Data stipula"
        source="contract_signing_date"
        format="DD/MM/YYYY"
      />
      <DateTimeField
        title="Data attivazione"
        source="activation_start_date"
        format="DD/MM/YYYY"
      />
      <DateTimeField
        title="Data Scadenza"
        source="contract_end_date"
        format="DD/MM/YYYY"
      />
      <AdminStateEnergyField title="Stato Gestione" />
      <Field
        title="Consumo da contratto iniziale"
        source="initial_contractual_consumption"
      />
      <Field title="Consumo da contratto" source="contractual_consumption" />
      <Field title="Consumo attuale" source="actual_consumption" />
      <ContractEONType title="Nome prodotto" source="product_name" />
      <Field title="Mensilità ricorrenze" source="recurringMonthlyPayment" />
      <CurrentAdminField title="Detentore" source="currentAdminInfo.name" />
      <ResponsibleField title="Intestatario" source="admin.name" />
      <CurrencyFieldInitialFixedValue
        title="Compenso fisso iniziale"
        source="energy_contract.initial_fixed_value"
      />
      <CurrencyFieldCentMc title="Fee iniziale a mc" />
      <CurrencyField title="Imponibile" source="contract_value" />
      <CurrencyField title="Profitto Extra" source="extraShare" />
      <CurrencyField title="Profitto Detentore" source="adminShare" />
      <ManageDocument
        title="Gestisci documento"
        handleFileListView={handleFileListView}
      />
      <ActionsField
        title="Azioni"
        toggleHistoryModal={toggleHistoryModal}
      ></ActionsField>
    </DataTable>
  );
}

export default ContractsTable;
